// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"3550a994","392":"18312e92","813":"d339f447","915":"9988f933"}[chunkId] + ".chunk.js";
};